import { TournamentTrick } from '../../../types';

const CKO2026_LEVEL_0_5_TRICKS: TournamentTrick[] = [
  { id: 'cko2026-0_5-1', name: '0.5-1 Easy Big Cup\n手放大皿', score: 0.5 },
  { id: 'cko2026-0_5-2', name: '0.5-2 Lazy Spike\n手放止剑', score: 0.5 },
  { id: 'cko2026-0_5-3', name: '0.5-3 Fish For Ken\n捞剑', score: 0.5 },
  { id: 'cko2026-0_5-4', name: '0.5-4 Back Pass\n环绕一周', score: 0.5 },
  { id: 'cko2026-0_5-5', name: '0.5-5 Bowling\n保龄球', score: 0.5 },
  { id: 'cko2026-0_5-6', name: '0.5-6 Jump Over The Kendama\n跳跃剑玉', score: 0.5 },
  { id: 'cko2026-0_5-7', name: '0.5-7 Downward Darts\n倒插飞镖', score: 0.5 },
  { id: 'cko2026-0_5-8', name: '0.5-8 Eiffel Tower\n巴黎铁塔', score: 0.5 },
  { id: 'cko2026-0_5-9', name: '0.5-9 Kendama 3-Hop\n持剑玉单脚三跳', score: 0.5 },
  { id: 'cko2026-0_5-10', name: '0.5-10 Kendama Switch Catch\n换手持剑玉', score: 0.5 }
];

const CKO2026_LEVEL_1_TRICKS: TournamentTrick[] = [
  { id: 'cko2026-1-1', name: '1-1 Takoyaki\n章鱼烧', score: 1 },
  { id: 'cko2026-1-2', name: '1-2 Spike\n止剑', score: 1 },
  { id: 'cko2026-1-3', name: '1-3 Base Cup\n中皿', score: 1 },
  { id: 'cko2026-1-4', name: '1-4 Airplane\n飞行机', score: 1 },
  { id: 'cko2026-1-5', name: '1-5 Candlestick\n烛台', score: 1 },
  { id: 'cko2026-1-6', name: '1-6 Big Cup, Orbit\n大皿，轨道一周', score: 1 },
  { id: 'cko2026-1-7', name: '1-7 Hanging Clap Catch\n抽线拍手', score: 1 },
  { id: 'cko2026-1-8', name: '1-8 Big Cup, Spike\n大皿，止剑', score: 1 },
  { id: 'cko2026-1-9', name: '1-9 Around Japan\n日本一周', score: 1 },
  { id: 'cko2026-1-10', name: '1-10 Moshikame x10 or More\n皿上来回x10或更多', score: 1 }
];

const CKO2026_LEVEL_2_TRICKS: TournamentTrick[] = [
  { id: 'cko2026-2-1', name: '2-1 Airplane, Jumping Toast Stick\n飞行机，敬酒跳剑', score: 2 },
  { id: 'cko2026-2-2', name: '2-2 Baseball\n棒球', score: 2 },
  { id: 'cko2026-2-3', name: '2-3 Around The World\n世界一周', score: 2 },
  { id: 'cko2026-2-4', name: '2-4 Frying Pan, Spike\n剑顶滑玉', score: 2 },
  { id: 'cko2026-2-5', name: '2-5 Darts\n飞镖', score: 2 },
  { id: 'cko2026-2-6', name: '2-6 Swing Spike, Flying Top\n游泳，竹蜻蜓', score: 2 },
  { id: 'cko2026-2-7', name: '2-7 Trapeze\n空中飞人', score: 2 },
  { id: 'cko2026-2-8', name: '2-8 1 Turn Lighthouse, Falling In\n1回转灯台，持球收', score: 2 },
  { id: 'cko2026-2-9', name: '2-9 Downspike\n天中杀', score: 2 },
  { id: 'cko2026-2-10', name: '2-10 Ladybug, Spike\n瓢虫，止剑', score: 2 }
];

const CKO2026_LEVEL_3_TRICKS: TournamentTrick[] = [
  { id: 'cko2026-3-1', name: '3-1 Base Cup, Trade Ghost Falling In\n中皿，幽灵持球收', score: 3 },
  { id: 'cko2026-3-2', name: '3-2 Downspike, Base Cup, Downspike\n天地二段', score: 3 },
  { id: 'cko2026-3-3', name: '3-3 Swing Spike, Whirlwind\n游泳，旋转地球', score: 3 },
  { id: 'cko2026-3-4', name: '3-4 Lunar, Falling In\n月面，持球收', score: 3 },
  { id: 'cko2026-3-5', name: '3-5 Gunslinger Spike\n神枪手止剑', score: 3 },
  { id: 'cko2026-3-6', name: '3-6 Bird, Spike\n大鸟，止剑', score: 3 },
  { id: 'cko2026-3-7', name: '3-7 Juggle Big Cup, Spike\n小丑大皿，止剑', score: 3 },
  { id: 'cko2026-3-8', name: '3-8 Around Europe\n欧洲一周', score: 3 },
  { id: 'cko2026-3-9', name: '3-9 Base Cup, Rising Dragon, Spike\n中皿，升龙，止剑', score: 3 },
  { id: 'cko2026-3-10', name: '3-10 Airplane, Base Cup, Downspike\n飞行机，中皿，天中杀', score: 3 }
];

const CKO2026_LEVEL_4_TRICKS: TournamentTrick[] = [
  { id: 'cko2026-4-1', name: '4-1 Flying V, Lighthouse, Falling In\n飞行V，灯台，持球收', score: 4 },
  { id: 'cko2026-4-2', name: '4-2 Swirl To Airplane\n螺旋飞行机', score: 4 },
  { id: 'cko2026-4-3', name: '4-3 Candle underbird, Trade spike\n烛台安德鸟，持剑收', score: 4 },
  { id: 'cko2026-4-4', name: '4-4 Around USA\n美国一周', score: 4 },
  { id: 'cko2026-4-5', name: '4-5 Bird Over The Valley, Spike\n鸟渡，止剑', score: 4 },
  { id: 'cko2026-4-6', name: '4-6 Handlestall, Falling In\n中皿极易，持球收', score: 4 },
  { id: 'cko2026-4-7', name: '4-7 1 Turn Lunar, Lunar Flip, Falling In\n1回转月面，月面翻转，持球收', score: 4 },
  { id: 'cko2026-4-8', name: '4-8 Juggle Spike\n小丑止剑', score: 4 },
  { id: 'cko2026-4-9', name: '4-9 Stilt, Downspike\n竹马，天中杀', score: 4 },
  { id: 'cko2026-4-10', name: '4-10 Swing Spike, Whirlwind, Inward Whirlwind\n游泳，离转地球，反离转地球', score: 4 }
];

const CKO2026_LEVEL_5_TRICKS: TournamentTrick[] = [
  { id: 'cko2026-5-1', name: '5-1 Around Denmark\n丹麦一周', score: 5 },
  { id: 'cko2026-5-2', name: '5-2 Stilt, Stilt Over The Valley, Flip In\n竹马，竹马渡，回转持球收', score: 5 },
  { id: 'cko2026-5-3', name: '5-3 Airplane, 1.5 Turn Swap Juggle Spike\n飞行机，1.5跳剑小丑止剑', score: 5 },
  { id: 'cko2026-5-4', name: '5-4 Ghost Lighthouse, Juggle Ghost Lighthouse, Falling In\n幽灵灯，小丑幽灵灯，持球收', score: 5 },
  { id: 'cko2026-5-5', name: '5-5 Gunslinger Late Kenflip Juggle Spike\n神枪手Late离转小丑止剑', score: 5 },
  { id: 'cko2026-5-6', name: '5-6 Swing Spike, Kenflip Late Inward Whirlwind\n游泳，离转Late反离转地球', score: 5 },
  { id: 'cko2026-5-7', name: '5-7 Tap Juggle Spike\nTap小丑止剑', score: 5 },
  { id: 'cko2026-5-8', name: '5-8 Airplane, 2 Tap Flip In\n飞行机，2 Tap回转持球收', score: 5 },
  { id: 'cko2026-5-9', name: '5-9 Airplane, Inward 3 Turn Jumping Stick\n飞行机，逆3圈跳剑', score: 5 },
  { id: 'cko2026-5-10', name: '5-10 Airplane, Inward 0.5 Turn Swap Ghost Lighthouse, Falling In\n飞行机，逆0.5回转换幽灵灯，持球收', score: 5 }
];

const CKO2026_LEVEL_6_TRICKS: TournamentTrick[] = [
  { id: 'cko2026-6-1', name: '6-1 Around Juggle\n小丑一周', score: 6 },
  { id: 'cko2026-6-2', name: '6-2 Stilt, Swap Juggle Bird, Ghost In\n竹马，小丑大鸟，幽灵持球收', score: 6 },
  { id: 'cko2026-6-3', name: '6-3 Naughty Bird, Gravity Drop In\n淘气鸟，重力转持球收', score: 6 },
  { id: 'cko2026-6-4', name: '6-4 Underbird, Gravity Penguin Underbird Back and Forth, Flip In\n安德鸟，重力企鹅安德鸟来回，地球止剑', score: 6 },
  { id: 'cko2026-6-5', name: '6-5 Airplane, 1-2-3 J-stick\n飞行机，跳剑1-2-3', score: 6 },
  { id: 'cko2026-6-6', name: '6-6 Inward Lunar, 1 Turn Tap Inward 1 Turn Inward Lunar, 1 Turn Tap Inward 1 Turn In\n逆月面，1回转Tap1回转逆月面，1回转Tap1回转持球收', score: 6 },
  { id: 'cko2026-6-7', name: '6-7 2 Tap Juggle Spike\n2 Tap小丑止剑', score: 6 },
  { id: 'cko2026-6-8', name: '6-8 1 Turn Lighthouse Insta 1 Turn Swap Gunslinger Juggle Spike\n1回转灯台insta 1回转换神枪手小丑止剑', score: 6 },
  { id: 'cko2026-6-9', name: '6-9 Around Stalls\n极易一周', score: 6 },
  { id: 'cko2026-6-10', name: '6-10 Kenflip Juggle Kenflip Juggle Spike\n离转小丑离转小丑止剑', score: 6 }
];

const CKO2026_LEVEL_7_TRICKS: TournamentTrick[] = [
  { id: 'cko2026-7-1', name: '7-1 Double Stunkflip Juggle Spike\n2圈Stunkflip小丑止剑（剑击打球后旋转）', score: 7 },
  { id: 'cko2026-7-2', name: '7-2 Naughty Bird, Half Rotation Over The Valley Naughty Bird, Flip In\n淘气鸟，翻转淘气鸟渡，地球止剑', score: 7 },
  { id: 'cko2026-7-3', name: '7-3 1 Turn Arm Bounce Swap Juggle Penguin Spike\n1回转手臂灯台insta小丑企鹅止剑', score: 7 },
  { id: 'cko2026-7-4', name: '7-4 Around Galaxy\n银河一周', score: 7 },
  { id: 'cko2026-7-5', name: '7-5 Swing Spike, Whirlslinger 1-2-3\n游泳，神枪手地球123', score: 7 },
  { id: 'cko2026-7-6', name: '7-6 2 Big Tap Swap 1.5 Turn Toss In\n2大Tap换抛1.5圈持球收', score: 7 },
  { id: 'cko2026-7-7', name: '7-7 Swing Spike, Juggle Spike, Double Kenflip Juggle Spike, Triple Kenflip Juggle Spike\n游泳，小丑止剑，2圈小丑止剑，3圈小丑止剑', score: 7 },
  { id: 'cko2026-7-8', name: '7-8 3 Tap Axe, In\n3 Tap战斧，持球收', score: 7 },
  { id: 'cko2026-7-9', name: '7-9 Downspike, 1.5 Turn Swap Stuntplane Fasthand\n天中杀1.5回转换玉中杀快手', score: 7 },
  { id: 'cko2026-7-10', name: '7-10 4 Tap Juggle Downspike\n4 Tap小丑天中杀', score: 7 }
];

const CKO2026_LEVEL_8_TRICKS: TournamentTrick[] = [
  { id: 'cko2026-8-1', name: '8-1 10 Juggle (or more) Spike\n10小丑（或更多）止剑', score: 8 },
  { id: 'cko2026-8-2', name: '8-2 3 Gunslinger Bird, 3 Gunslinger Spike\n3神枪手大鸟，3神枪手止剑', score: 8 },
  { id: 'cko2026-8-3', name: '8-3 Inward Lunar, 1-2-3 Inward Lunar Flip, In\n逆月面，逆月1-2-3，持球收', score: 8 },
  { id: 'cko2026-8-4', name: '8-4 Tap Juggle Switch Tap Switch Swap Juggle Spike\nTap小丑换手Tap换手小丑止剑', score: 8 },
  { id: 'cko2026-8-5', name: '8-5 2 Gunslinger Late Kenflip Spike, 2 Gunslinger Late Whirlwind\n2神枪手Late离转止剑，2神枪手Late离转地球', score: 8 },
  { id: 'cko2026-8-6', name: '8-6 Airplane, 1.5 Turn Late 3 Kenflip 1.5 Turn Toss In\n飞行机，1.5换剑Late 3离转1.5持球收', score: 8 },
  { id: 'cko2026-8-7', name: '8-7 Tap Juggle x3 Spike\nTap小丑x3止剑', score: 8 },
  { id: 'cko2026-8-8', name: '8-8 Swing Big Wing, Juggle Big Wing, Flip In\n游泳极易，小丑大皿极易，地球止剑', score: 8 },
  { id: 'cko2026-8-9', name: '8-9 Inward Lunar, 1 Turn Cushion Juggle Cushion Inward Lunar, In\n逆月面，一圈Cushion小丑Cushion逆月，持球收', score: 8 },
  { id: 'cko2026-8-10', name: '8-10 Stuntplane, 3 Stuntplane Flip Fasthand\n玉中杀，3圈玉中杀快手', score: 8 }
];

const CKO2026_LEVEL_9_TRICKS: TournamentTrick[] = [
  { id: 'cko2026-9-1', name: '9-1 Around Big Wing, Earthturn In\n大皿极易一周，地球止剑', score: 9 },
  { id: 'cko2026-9-2', name: '9-2 1.5 Gooncircle String Pinch Bird, Spike\n1.5圆月提线大鸟，止剑', score: 9 },
  { id: 'cko2026-9-3', name: '9-3 Airplane, 1.5 Turn Swap Juggle Late Inward Kenflip Juggle x3 Swap 1.5 Turn Toss In\n飞行机，1.5离转小丑，反离转小丑x3，抛1.5圈持球入', score: 9 },
  { id: 'cko2026-9-4', name: '9-4 Around Stall Nod Off  On Stall, Earthturn In\n燕返一周，地球止剑', score: 9 },
  { id: 'cko2026-9-5', name: '9-5 Downspike Rising Switch To Arm Stall, Pirouette Catch\n天中杀转手手臂停剑，转身接剑', score: 9 },
  { id: 'cko2026-9-6', name: '9-6 1 Turn Lighthouse Insta Flip Toss Lighthouse Insta 2 Flip Toss Lighthouse Insta 3 Flip Swap Spike\n1圈转灯台insta 1回转抛灯insta 2回转抛灯insta 3回转抛持剑收', score: 9 },
  { id: 'cko2026-9-7', name: '9-7 Gunslinger Inward Toss Tap Juggle Late Gunslinger Inward Toss Tap Swap Spike\n神枪手逆抛剑Tap小丑Late神枪手逆抛剑Tap换手收剑', score: 9 },
  { id: 'cko2026-9-8', name: '9-8 Inward Lunar, 3 Turn Inward Lunar Flip x 3, In\n逆月3圈x3，持球收', score: 9 },
  { id: 'cko2026-9-9', name: '9-9 6 Tap Juggle Spike\n6 Tap小丑止剑', score: 9 },
  { id: 'cko2026-9-10', name: '9-10 2 Big Tap Swap 2 Tap Juggle Bird, Trade Downspike\n2大Tap 2Tap小丑鸟，天中杀', score: 9 }
];

const CKO2026_LEVEL_10_TRICKS: TournamentTrick[] = [
  { id: 'cko2026-10-1', name: '10-1 Kenflip-flip-flip Juggle Kenflip-flip-flip Juggle Kenflip-flip-flip Spike\n离转Late离转Late离转小丑离转Late离转Late离转小丑止剑', score: 10 },
  { id: 'cko2026-10-2', name: '10-2 Airplane, 3 Turn Swap Candle Handlestall, Kenflip Downspike\n飞行机，3跳剑换烛台中皿极易，离转天中杀', score: 10 },
  { id: 'cko2026-10-3', name: '10-3 1 Turn Lighthouse (Insta Lighthouse Flip) x9 Insta 1 Turn Trade Spike\n1回转灯台（Insta灯上1回x9）Insta 1回转持剑收', score: 10 },
  { id: 'cko2026-10-4', name: '10-4 Candle Handlestall, 1.5 Juggle Non Grip Handlestall, 1.5 Juggle Sarado Grip Handlestall, Downspike Fasthand\n烛台中皿极易，1.5小丑中皿极易，1.5小丑勺式拿法中皿极易，天中杀快手', score: 10 },
  { id: 'cko2026-10-5', name: '10-5 Bird, Knee Bounce Flip Bird, Spike\n大鸟，膝1回转大鸟，止剑', score: 10 },
  { id: 'cko2026-10-6', name: '10-6 Big Tap ， Tap Juggle Kenflip Juggle  Downspike  Kenflip Juggle  Big Tap ， Tap Juggle Kenflip Juggle Downspike\n大Tap-3Tap小丑离转小丑快手灯台，大Tap-Tap小丑离转小丑天中杀', score: 10 },
  { id: 'cko2026-10-7', name: '10-7 Inward Lunar, Flip Tap Inward Flip Inward Lunar Insta 1 Turn Swap Gunslinger Toss Tap Inward Flip Inward Lunar Insta Toss Tap Swap 1 Turn In\n逆月面，翻转Tap翻转逆月面Insta 1回转换神枪手抛剑Tap翻转逆月面Insta抛剑Tap换1回转持球收', score: 10 },
  { id: 'cko2026-10-8', name: '10-8 3 Turn Inward Non Throw Tap Juggle x 2 Swap 3 Turn Inward Non Throw Tap Swap Spike\n3圈逆抛剑Tap小丑x2换3圈逆抛剑Tap换手止剑', score: 10 },
  { id: 'cko2026-10-9', name: '10-9 2 Tap 1.5 Juggle Sarado Grip Switch Candle Grip 1.5 Juggle 4 Tap Juggle Down Turn Stuntplane Fasthand\n4 Tap 1.5小丑勺式拿法换烛台拿法1.5小丑4 Tap小丑下转玉中杀快手', score: 10 },
  { id: 'cko2026-10-10', name: '10-10 Gooncircle 1-2-3-2 Kenflip Juggle Late Gooncircle Juggle Downspike\n圆月1-2-3-2离转小丑Late圆月小丑天中杀', score: 10 }
];

export const CKO2026_TRICKS: TournamentTrick[] = [
  ...CKO2026_LEVEL_0_5_TRICKS,
  ...CKO2026_LEVEL_1_TRICKS,
  ...CKO2026_LEVEL_2_TRICKS,
  ...CKO2026_LEVEL_3_TRICKS,
  ...CKO2026_LEVEL_4_TRICKS,
  ...CKO2026_LEVEL_5_TRICKS,
  ...CKO2026_LEVEL_6_TRICKS,
  ...CKO2026_LEVEL_7_TRICKS,
  ...CKO2026_LEVEL_8_TRICKS,
  ...CKO2026_LEVEL_9_TRICKS,
  ...CKO2026_LEVEL_10_TRICKS
];
